import { useAuthStore } from '../store';
import { useLogin, useLogout, useRegister } from '../api';
import { api } from '@/lib/api';

export function useAuth() {
  const { user, token, isAuthenticated, setAuth, clearAuth } = useAuthStore();
  const loginMutation = useLogin();
  const registerMutation = useRegister();
  const logoutMutation = useLogout();

  const login = async (email: string, password: string) => {
    const response = await loginMutation.mutateAsync({ email, password });
    api.setAuthToken(response.token);
    setAuth(response.user, response.token);
    return response;
  };

  const register = async (email: string, password: string, name: string) => {
    const response = await registerMutation.mutateAsync({ email, password, name });
    api.setAuthToken(response.token);
    setAuth(response.user, response.token);
    return response;
  };

  const logout = async () => {
    await logoutMutation.mutateAsync();
    api.clearAuthToken();
    clearAuth();
  };

  return {
    user,
    token,
    isAuthenticated,
    login,
    register,
    logout,
    isLoggingIn: loginMutation.isPending,
    isRegistering: registerMutation.isPending,
    isLoggingOut: logoutMutation.isPending,
  };
}
